import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=356e1c27&scoped=true"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPanel.vue?vue&type=style&index=0&id=356e1c27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e1c27",
  null
  
)

export default component.exports